import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import * as TimeCardDocumentationActions from './time-card-documentation.actions';
import { TimeCardDocumentation } from './time-card-documentation.model';

export const timeCardDocumentationsFeatureKey = 'timeCardDocumentations';

export interface State extends EntityState<TimeCardDocumentation> {
    // additional entities state properties
}
// have to specify function to get the uniqueid column since we're not using "id"
export const adapter: EntityAdapter<TimeCardDocumentation> =
    createEntityAdapter<TimeCardDocumentation>({
        selectId: (model: TimeCardDocumentation) => model.id as string
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const timeCardDocumentationReducer = createReducer(
    initialState,
    on(TimeCardDocumentationActions.addTimeCardDocumentation, (state, action) =>
        adapter.addOne(action.timeCardDocumentation, state)
    ),
    on(
        TimeCardDocumentationActions.upsertTimeCardDocumentation,
        (state, action) =>
            adapter.upsertOne(action.timeCardDocumentation, state)
    ),
    on(
        TimeCardDocumentationActions.addTimeCardDocumentations,
        (state, action) => adapter.addMany(action.timeCardDocumentations, state)
    ),
    on(
        TimeCardDocumentationActions.upsertTimeCardDocumentations,
        (state, action) =>
            adapter.upsertMany(action.timeCardDocumentations, state)
    ),
    on(
        TimeCardDocumentationActions.updateTimeCardDocumentation,
        (state, action) =>
            adapter.updateOne(action.timeCardDocumentation, state)
    ),
    on(
        TimeCardDocumentationActions.updateTimeCardDocumentations,
        (state, action) =>
            adapter.updateMany(action.timeCardDocumentations, state)
    ),
    on(
        TimeCardDocumentationActions.deleteTimeCardDocumentation,
        (state, action) => adapter.removeOne(action.id as string, state)
    ),
    on(
        TimeCardDocumentationActions.deleteTimeCardDocumentations,
        (state, action) => adapter.removeMany(action.ids as string[], state)
    ),
    on(
        TimeCardDocumentationActions.loadTimeCardDocumentations,
        (state, action) => adapter.setAll(action.timeCardDocumentations, state)
    ),
    on(TimeCardDocumentationActions.clearTimeCardDocumentations, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return timeCardDocumentationReducer(state, action);
}
const localState = createFeatureSelector<State>(
    timeCardDocumentationsFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(localState);
